import { QTY_MAX_VALUE } from "@eisinc/XDL/constants";
import { useEffect, useState } from "react";

const enterKey = 13;

const isValidNumberic = (number: string, regexp: RegExp) => {
    if (number === "") {
        // backspace or delete case
        return true;
    }
    return regexp.test(number);
};
const useAccessibleSubmit = (
    value: string,
    onSubmit: (value: string) => void,
    cartLoadedTime?: number,
    allowFractionalQty?: boolean,
    minQty?: string,
    multipleSaleQty?: string,
) => {
    const [stateValue, setValue] = useState(value);
    const regexp = allowFractionalQty ? /^[0-9]*[.,]?[0-9]*$/ : /^[0-9\b]+$/;

    // <xng-change> prevent non-numeric values on input for quantity - this is only used for cartLine inputs
    const changeHandler = (event: any) => {
        if (!isValidNumberic(event.currentTarget.value, regexp)) {
            event.preventDefault();
            return;
        }
        setValue(event.currentTarget.value);
    };
    // <xng-change>

    const keyDownHandler = (event: any) => {
        if (event.keyCode === enterKey) {
            event.stopPropagation();
            if (
                event.currentTarget.value !== "" &&
                isValidNumberic(event.currentTarget.value, regexp) &&
                parseFloat(event.currentTarget.value) <= QTY_MAX_VALUE
            ) {
                onSubmit(stateValue);
            }
        }
    };

    const blurHandler = (event: any) => {
        let newValue = event ? event.currentTarget.value : stateValue;
        if (newValue !== "" && parseFloat(newValue) <= QTY_MAX_VALUE) {
            if (minQty && parseFloat(newValue) < parseFloat(minQty)) {
                setValue(minQty);
                onSubmit(minQty);
            } else {
                if (multipleSaleQty && parseFloat(multipleSaleQty) > 0 && newValue % parseFloat(multipleSaleQty) !== 0) {
                    newValue = Math.ceil(newValue / parseFloat(multipleSaleQty)) * parseFloat(multipleSaleQty);
                    setValue(newValue);
                }
                onSubmit(newValue);
            }
        } else {
            setValue(value);
        }
    };

    useEffect(() => {
        setValue(value);
    }, [value, cartLoadedTime]);

    return {
        value: stateValue,
        changeHandler,
        keyDownHandler,
        blurHandler,
    };
};
export default useAccessibleSubmit;
